// Auto generated file, do not manually modify!
// com.hotpads.capps.enums.ClearableAnswerField

export enum ClearableAnswerField {
  ACCOUNTANT_CONTACT = 'ACCOUNTANT_CONTACT',
  ATTORNEY_CONTACT = 'ATTORNEY_CONTACT',
  BACKGROUND_REPORT_COMMENT = 'BACKGROUND_REPORT_COMMENT',
  BROKERAGE_CONTACT = 'BROKERAGE_CONTACT',
  CAN_CONTACT_EMPLOYER = 'CAN_CONTACT_EMPLOYER',
  CAN_CONTACT_LANDLORDS = 'CAN_CONTACT_LANDLORDS',
  CREDIT_REPORT_COMMENT = 'CREDIT_REPORT_COMMENT',
  CURRENT_RESIDENCE = 'CURRENT_RESIDENCE',
  FIRST_NAME = 'FIRST_NAME',
  HAS_SERVICE_ANIMAL = 'HAS_SERVICE_ANIMAL',
  IS_LEASE_LENGTH_FLEXIBLE = 'IS_LEASE_LENGTH_FLEXIBLE',
  IS_MOVE_IN_DATE_FLEXIBLE = 'IS_MOVE_IN_DATE_FLEXIBLE',
  IS_SMOKER = 'IS_SMOKER',
  LAST_NAME = 'LAST_NAME',
  MIDDLE_NAME = 'MIDDLE_NAME',
  MOVE_IN_DATE = 'MOVE_IN_DATE',
  OCCUPANTS = 'OCCUPANTS',
  PERSONAL_REFERENCES = 'PERSONAL_REFERENCES',
  PETS = 'PETS',
  PHONE = 'PHONE',
  PREFERRED_LEASE_LENGTHS = 'PREFERRED_LEASE_LENGTHS',
  REASON_FOR_MOVING = 'REASON_FOR_MOVING',
  VEHICLES = 'VEHICLES',
}

export const ClearableAnswerField_values = [
  ClearableAnswerField.ACCOUNTANT_CONTACT,
  ClearableAnswerField.ATTORNEY_CONTACT,
  ClearableAnswerField.BACKGROUND_REPORT_COMMENT,
  ClearableAnswerField.BROKERAGE_CONTACT,
  ClearableAnswerField.CAN_CONTACT_EMPLOYER,
  ClearableAnswerField.CAN_CONTACT_LANDLORDS,
  ClearableAnswerField.CREDIT_REPORT_COMMENT,
  ClearableAnswerField.CURRENT_RESIDENCE,
  ClearableAnswerField.FIRST_NAME,
  ClearableAnswerField.HAS_SERVICE_ANIMAL,
  ClearableAnswerField.IS_LEASE_LENGTH_FLEXIBLE,
  ClearableAnswerField.IS_MOVE_IN_DATE_FLEXIBLE,
  ClearableAnswerField.IS_SMOKER,
  ClearableAnswerField.LAST_NAME,
  ClearableAnswerField.MIDDLE_NAME,
  ClearableAnswerField.MOVE_IN_DATE,
  ClearableAnswerField.OCCUPANTS,
  ClearableAnswerField.PERSONAL_REFERENCES,
  ClearableAnswerField.PETS,
  ClearableAnswerField.PHONE,
  ClearableAnswerField.PREFERRED_LEASE_LENGTHS,
  ClearableAnswerField.REASON_FOR_MOVING,
  ClearableAnswerField.VEHICLES,
] as const;
